import {flex, flexDirection, mb} from "@pg-design/helpers-css";

import {useOfferListingAbroadView} from "../../../offer/list/hooks/use_offer_listing_abroad_view_check";
import {OfferType} from "../../../offer/types/OfferType";
import {ISearchFilter} from "../../types/ISearchFilters";
import {calculateNewOfferTypeArray} from "../../utils/calculate_new_offer_type_array";
import {FilterCheckbox} from "./FilterCheckbox";

interface IProps {
    filter: ISearchFilter<string, OfferType>;
    value: OfferType[];
    onChange: (name: string, value: OfferType[]) => void;
}

const filterOptions = [
    {
        id: OfferType.FLAT.toString(),
        value: OfferType.FLAT,
        label: "Mieszkania"
    },
    {
        id: OfferType.HOUSE.toString(),
        value: OfferType.HOUSE,
        label: "Domy"
    },
    {
        id: OfferType.COMMERCIAL.toString(),
        value: OfferType.COMMERCIAL,
        label: "Lokale użytkowe",
        isDisabled: false
    }
] as const;

export const FilterOfferType = (props: IProps) => {
    const isAbroadOffersView = useOfferListingAbroadView();
    const onTypeClick = (toggleType: OfferType) => {
        const newValue = calculateNewOfferTypeArray(props.value, toggleType);
        props.onChange(props.filter.id, newValue);
    };

    const isValueEmpty = props.value.length === 0;
    const isChecked = {
        [OfferType.FLAT]: isValueEmpty || props.value.includes(OfferType.FLAT),
        [OfferType.HOUSE]: isValueEmpty || props.value.includes(OfferType.HOUSE),
        [OfferType.COMMERCIAL]: props.value.includes(OfferType.COMMERCIAL)
    };

    return (
        <div css={[flex("flex-start", "space-between"), flexDirection("column")]}>
            {filterOptions.map((filterOption) => {
                const disabled = filterOption.value === OfferType.COMMERCIAL && isAbroadOffersView;
                return (
                    <FilterCheckbox
                        key={filterOption.id}
                        filterId={props.filter.id}
                        filterOption={{...filterOption, isDisabled: disabled}}
                        onChange={() => onTypeClick(filterOption.value)}
                        isChecked={isChecked[filterOption.value]}
                        css={mb(1)}
                    />
                );
            })}
        </div>
    );
};
import {flex, flexDirection, mb} from "@pg-design/helpers-css";

import {useOfferListingAbroadView} from "../../../offer/list/hooks/use_offer_listing_abroad_view_check";
import {OfferType} from "../../../offer/types/OfferType";
import {ISearchFilter} from "../../types/ISearchFilters";
import {calculateNewOfferTypeArray} from "../../utils/calculate_new_offer_type_array";
import {FilterCheckbox} from "./FilterCheckbox";

interface IProps {
    filter: ISearchFilter<string, OfferType>;
    value: OfferType[];
    onChange: (name: string, value: OfferType[]) => void;
}

const filterOptions = [
    {
        id: OfferType.FLAT.toString(),
        value: OfferType.FLAT,
        label: "Mieszkania"
    },
    {
        id: OfferType.HOUSE.toString(),
        value: OfferType.HOUSE,
        label: "Domy"
    },
    {
        id: OfferType.COMMERCIAL.toString(),
        value: OfferType.COMMERCIAL,
        label: "Lokale użytkowe",
        isDisabled: false
    }
] as const;

export const FilterOfferType = (props: IProps) => {
    const isAbroadOffersView = useOfferListingAbroadView();
    const onTypeClick = (toggleType: OfferType) => {
        const newValue = calculateNewOfferTypeArray(props.value, toggleType);
        props.onChange(props.filter.id, newValue);
    };

    const isValueEmpty = props.value.length === 0;
    const isChecked = {
        [OfferType.FLAT]: isValueEmpty || props.value.includes(OfferType.FLAT),
        [OfferType.HOUSE]: isValueEmpty || props.value.includes(OfferType.HOUSE),
        [OfferType.COMMERCIAL]: props.value.includes(OfferType.COMMERCIAL)
    };

    return (
        <div css={[flex("flex-start", "space-between"), flexDirection("column")]}>
            {filterOptions.map((filterOption) => {
                const disabled = filterOption.value === OfferType.COMMERCIAL && isAbroadOffersView;
                return (
                    <FilterCheckbox
                        key={filterOption.id}
                        filterId={props.filter.id}
                        filterOption={{...filterOption, isDisabled: disabled}}
                        onChange={() => onTypeClick(filterOption.value)}
                        isChecked={isChecked[filterOption.value]}
                        css={mb(1)}
                    />
                );
            })}
        </div>
    );
};
